import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2803f6b6&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=2803f6b6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2803f6b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2803f6b6')) {
      api.createRecord('2803f6b6', component.options)
    } else {
      api.reload('2803f6b6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2803f6b6&scoped=true", function () {
      api.rerender('2803f6b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kpi-analytics/index.vue"
export default component.exports